import React, { useEffect, useState } from 'react';

interface CDNImageBase64Props {
	imageUrl: string;
	partUrl: string;
}

const CDNImageBase64: React.FC<CDNImageBase64Props> = ({ imageUrl, partUrl }) => {
	const [ base64, setBase64 ] = useState<string | null>(null);

	useEffect(() => {
		if ( !imageUrl ) {
			return;
		}

		const encodedUrl = encodeURIComponent(imageUrl);

		fetch(`/wp-json/timken-api/v1/convert-image-to-base64?url=${encodedUrl}`)
			.then((res) => {
				if (!res.ok) {
					throw new Error(`HTTP error, status = ${res.status}`);
				}

				return res.text();
			})
			.then((url) => {
				const cleaned = url.replace(/\\\//g, '/');
				setBase64(cleaned);
			})
			.catch((err) => {
				console.error('Failed to fetch base64 image:', err);
			});
	}, [imageUrl]);

	return (
		<div>
			{base64 && (
				<a href={partUrl}>
					<img
						src={base64}
						alt=""/>
				</a>
			)
			}
		</div>
	)
		;
};

export default CDNImageBase64;
